export default __webpack_public_path__ + "static/04-417eec0defdfe9f709f610559dec7216.png";